<template>
  <div v-if="customer.flags?.includes('is_employee') && state.merchantConfig.widgets.showEmployeeTitle" class="gmf-level-row gmf-text-small">
    <span class="gmf-customer-title" v-text="t('comments.employee_title')"></span>
  </div>
  <div v-else-if="showAny && !customer.isGuest">
    <div class="gmf-level-row gmf-text-small">
      <div class="gmf-level-row-group" @click="onClick">
        <span class="gmf-level-row-level" v-if="showLevel">{{ t('profile_card.level') + ' ' + level }}</span>
        <span v-if="customer.levelName && showTitle" class="gmf-customer-title">{{ title }}</span>
      </div>
    </div>
  </div>
  <div class="gmf-level-row gmf-text-small" v-else-if="showAny">
    <span class="gmf-level-row-level">{{ t('comments.guest') }}</span>
  </div>
</template>

<style>
.gmf-level-row {
  display: flex;
  align-items: center;
  gap: var(--gmf-p-2);
  flex-wrap: wrap;
  font-weight: bold;
}

.gmf-level-row-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--gmf-p-2);
}

.gmf-context .gmf-level-row-level {
  color: var(--gmf-col-level);
  font-weight: bold;
}
</style>

<script>
import openLevelModal from '@/widgets/LevelList/openLevelModal';
import state from '@/state';
const t = state.t;

export default {
  props: ['customer'],
  data() {
    return {
      state,
    }
  },
  methods: {
    t,
    openLevelModal,
    onClick() {
      if (state.merchantConfig?.widgets?.enableLevelModal && state.isLoggedIn()) {
        if (this.profile?.id === this.customer.id) {
          this.openLevelModal();
          return false;
        }
      }

      return true;
    },
    popupProfileCardEnabled() {
      if (!this.publicProfile) {
        return false
      }
      return !!state.merchantConfig?.popupProfileCard?.enabled;
    },
    publicProfile() {
      if (!this.customer) {
        return false;
      }

      return !this.customer.isGuest && this.customer.publicProfile;
    },
  },
  computed: {
    level() {
      return this.customer.level || this.customer.customerLevel || 0;
    },
    title() {
      return this.customer.levelName || this.customer.customerLevelName || null;
    },
    levelDisplayType() {
      const ldt = state.merchantConfig.widgets.levelDisplayType;
      return ldt || 'none';
    },
    showAny() {
      return this.showLevel || this.showTitle;
    },
    showLevel() {
      const ldt = this.levelDisplayType;
      return ldt === 'all' || ldt === 'levelOnly';
    },
    showTitle() {
      const ldt = this.levelDisplayType;
      return ldt === 'all' || ldt === 'titleOnly';
    },
    profile() {
      return this.state.profile;
    },
  },
};
</script>
